import { List } from '@/models/list/list'
import { MailWizzInstanceService } from './mail-wizz-instance.serive';

export class ListService extends MailWizzInstanceService {
    protected getResourceUrl() { return 'api/lists' };
    protected getResponseMapper() { return List.parseJson }
}

export const listService = new ListService();
